import { createComponent } from '@carvana/merch-components';

export const Tile = createComponent('div', {
  className:
    'flex h-full flex-col items-center justify-center rounded-md border border-grey-2 bg-blue-5 text-white'
});

export const TileText = createComponent('div', {
  className: 'max-w-[175px] text-center !font-bold tl-body-l'
});

export const IconWrapper = createComponent('div', {
  className:
    'mt-24 flex h-36 w-36 items-center justify-center border border-white'
});
